export default {
  appTitle: 'هوشمند طب',
  panelTitle: 'داشبورد مدیریت هوشمند طب',
  copyRight: 'کلیه حقوق این سایت متعلق به @:(branding.appTitle) می‌باشد',
}
